"use strict";

import axios from "axios"
let bus = new Vue();

Vue.component("edLink", {
    props: ["getUrl", "title"],
    data() {
        return {
            isActive: false // TODO: class modifier
        }
    },
    mounted() {
        bus.$on("loadPage", this.setInactive)
    },
    // put real links here for browser url preview
    template:"<a @click.prevent='clickLink()' v-bind:href='getUrl' v-bind:class='{ active: isActive }' target='_blank'><i class='fas fa-chevron-right'></i> {{ title }}</a>",
    methods: {
        clickLink() {
            bus.$emit("loadPage", this.getUrl);
            this.isActive = true;
        },
        setInactive(url) {
            if (url !== this.getUrl) {
                this.isActive = false;
            }
        }
    }
});

Vue.component("edContent", {
    props: ["startUrl"],
    data() {
        return {
            body: ""
        };
    },
    template:"<div v-html='body' ref='jump'></div>",

    created() {
        bus.$on("loadPage", this.loadPage);
        this.loadPage(this.startUrl, true);
    },

    methods: {
        loadPage(url, autoLoad = false) {
            axios.get(url)
                .then((response) => {
                    console.log(response);
                    this.setPageContent(response.data.trim());

                    if (window.innerWidth < 770 && !autoLoad) {
                        let posY = this.$refs.jump.getBoundingClientRect().top;
                        // add scroll position because getBoundingClientRect is relative to current position
                        window.scrollTo(0, posY + window.scrollY - 150);
                    }

                })
                .catch((error) => {
                    console.error(error);
                })
        },
        setPageContent(html) {
            // https://stackoverflow.com/a/35385518
            let template = document.createElement("template");
            template.innerHTML = html;
            let page = template.content.querySelector("#page");
            this.body = page.innerHTML;
        }
    }
});

// wrapping component
Vue.component("eventDetails", {

    data() {
        return {
        }
    },

    methods: {}
});



// WEBPACK FOOTER //
// ./frontend/js/event-details.js